import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { plotBackground } from "../../../config/colors";
import { TostadorFetching } from "../../../class/fetchTostador";
import { useDate } from "../../../hooks/useDate";
import "../Tostador.css";

export default function PerfilTroneras() {
  const initialFetch = new TostadorFetching().setIdSeccion(4).setSecuencia(12);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  const [corrienteValvulaRotatoria1, setCorrienteValvulaRotatoria1] =useState(defaultObject);
  const [corrienteValvulaRotatoria2, setCorrienteValvulaRotatoria2] =useState(defaultObject);
  const [temperaturaTronera1, setTemperaturaTronera1] = useState(defaultObject);
  const [temperaturaTronera2, setTemperaturaTronera2] = useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      if (data) {
        populateCorrienteValvulaRotatoria1(data);
        populateCorrienteValvulaRotatoria2(data);
        populateTemperaturaTronera1(data);
        populateTemperaturaTronera2(data);
        // usamos el hook de fecha para guardar los datos del periodo
        setDateHook(data, "Corriente Válvula Rotatoria 1");
      }
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateCorrienteValvulaRotatoria1(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente Válvula Rotatoria 1"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteValvulaRotatoria1({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteValvulaRotatoria2(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente Válvula Rotatoria 2"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteValvulaRotatoria2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTemperaturaTronera1(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Tronera 1"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTemperaturaTronera1({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTemperaturaTronera2(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Tronera 2"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTemperaturaTronera2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Troneras"}
            subtitle={"Periodo " + fullDate()}
          >
            {/** -------------------------------- Corriente Válvula Rotatoria 1 --------------------------------------- */}
            <Chart.Line
              name="Corriente Válvula Rotatoria 1"
              data={corrienteValvulaRotatoria1.value}
              yAxis={1}
            />

            {/** -------------------------------- Corriente Válvula Rotatoria 2 --------------------------------------- */}
            <Chart.Line
              name="Corriente Válvula Rotatoria 2"
              data={corrienteValvulaRotatoria2.value}
              yAxis={1}
            />

            {/** -------------------------------- Temperatura Tronera 1 --------------------------------------- */}
            <Chart.Line
              name="Temperatura Tronera 1"
              data={temperaturaTronera1.value}
              yAxis={0}
            />

            {/** -------------------------------- Temperatura Tronera 2 --------------------------------------- */}
            <Chart.Line
              name="Temperatura Tronera 2"
              data={temperaturaTronera2.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={corrienteValvulaRotatoria1.fecha} />

            <Chart.YAxis
              labelSuffix=" °C"
              title="Temperatura, °C"
              lineWidth={2}
              lineColor="white"
              min={0}
            />

            <Chart.YAxis
              labelSuffix=" A"
              title="Corriente, A"
              lineWidth={2}
              lineColor="white"
              opposite={true}
              tooltipValueFormat=" A"
              min={0}
              max={5}
            />

           
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
